<template>
  <FreeBottomSheet :name="roamingConfig.DEVICES_BOTTOM_SHEET">
    <template #header="{ hide }">
      <FreeHeader class="bg-background-neutral-primary rounded-t-2xl p-4">
        <template #default>
          <h2 class="text-text-neutral-primary text-base font-medium">
            {{
              isDeviceSelectionMode
                ? t('roamingDevices.choose-brand')
                : t('roamingDevices.title')
            }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="onClose(hide)" />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div
        class="bg-background-neutral-primary px-4 pb-4"
        :class="{ 'pt-4': !isDeviceSelectionMode }"
      >
        <div
          v-if="isDeviceSelectionMode"
          class="bg-background-neutral-secondary divide-situational-lightgrey divide-y rounded-xl px-4"
        >
          <button
            v-for="device in roamingConfig.DEVICES"
            :key="device.title"
            type="button"
            class="flex w-full items-center justify-between py-4"
            @click="onSelectBrand(device.title)"
          >
            <span
              class="font-semibold"
              :class="
                selectedBrand === device.title
                  ? 'text-text-positive-primary'
                  : 'text-text-neutral-secondary'
              "
            >
              {{ device.title }}
            </span>
            <img
              v-if="selectedBrand === device.title"
              src="./assets/tick-icon.svg"
              class="h-6 w-6"
              width="24"
              height="24"
              alt=""
              role="presentation"
            />
          </button>
        </div>
        <template v-else>
          <DeviceWarning class="mb-4" />
          <RoamingSelectBrandButton
            class="mb-4"
            :selected-brand="selectedBrand"
            @onClick="isDeviceSelectionMode = !isDeviceSelectionMode"
          />
          <div
            class="bg-background-neutral-secondary mb-6 rounded-2xl px-4 py-3"
          >
            <p
              v-for="device in selectedDevices"
              :key="device"
              class="text-text-neutral-secondary"
            >
              {{ device }}
            </p>
          </div>

          <FreeButton class="green-main-button w-full" @click="hide">
            {{ t('roamingDevices.close') }}
          </FreeButton>
        </template>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { computed, ref } from 'vue';
  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
    FreeButton,
  } from 'freedom-shared';

  import { roamingConfig } from '../config';
  import DeviceWarning from './DeviceWarning.vue';
  import RoamingSelectBrandButton from './RoamingSelectBrandButton.vue';

  const { t } = useI18n();

  const selectedBrand = ref<string>(roamingConfig.DEVICES[0].title);
  const isDeviceSelectionMode = ref<boolean>(false);

  const selectedDevices = computed(
    () =>
      roamingConfig.DEVICES.find(device => device.title === selectedBrand.value)
        ?.items,
  );

  function onSelectBrand(brand: string) {
    selectedBrand.value = brand;
    isDeviceSelectionMode.value = false;
  }

  function onClose(hide: () => void) {
    if (isDeviceSelectionMode.value) {
      isDeviceSelectionMode.value = false;
    } else {
      hide();
    }
  }
</script>

<i18n src="../locales.json" />
